import { render, staticRenderFns } from "./diy.vue?vue&type=template&id=341dfc78&scoped=true&"
import script from "./diy.vue?vue&type=script&lang=js&"
export * from "./diy.vue?vue&type=script&lang=js&"
import style0 from "./diy.vue?vue&type=style&index=0&id=341dfc78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341dfc78",
  null
  
)

export default component.exports